/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "../ColorsProvider";
import prefixStyles, { type StylesObject } from "../utils/prefixStyles";
import NoStyleButton from "../NoStyleButton";
import Tappable, { simpleActiveBackgroundColor } from "../Tappable";
import { IconCircledArrowUp, IconCircledArrowDown } from "../Icons";

type Props = {
  children?: ?React.Node,
  onUp?: ?() => void,
  onDown?: ?() => void,
  upDisabled?: ?boolean,
  downDisabled?: ?boolean,
  style?: ?StylesObject,
  upButtonStyle?: ?StylesObject,
  downButtonStyle?: ?StylesObject,
  childWrapperStyle?: ?StylesObject,
  label?: ?React.Node,
  isHeat?: ?boolean,
  isCool?: ?boolean,
  "aria-controls"?: ?string,
  colors: ColorSet,
};

class NumericUpDownPicker extends React.Component<Props> {
  render() {
    const {
      children,
      onUp,
      onDown,
      upDisabled,
      downDisabled,
      style,
      upButtonStyle,
      downButtonStyle,
      childWrapperStyle,
      label,
      isHeat,
      isCool,
      "aria-controls": ariaControls,
      colors,
    } = this.props;
    let colorTheme = "black";
    if (isHeat) {
      colorTheme = colors.HEAT;
    } else if (isCool) {
      colorTheme = colors.COOL;
    }
    const iconStyle = {
      cursor: "pointer",
      width: 40,
      height: 40,
      outline: "none",
    };

    const styles = {
      container: prefixStyles({
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        ...style,
      }),
      button: {
        borderRadius: "50%",
        width: "40px",
        margin: "0 auto",
      },
      upButton: {
        color: colorTheme,
        ...iconStyle,
        ...upButtonStyle,
        ...(upDisabled ? { opacity: "0.5" } : null),
      },
      downButton: {
        color: colorTheme,
        ...iconStyle,
        ...downButtonStyle,
        ...(downDisabled ? { opacity: "0.5" } : null),
      },
      labelWrapper: prefixStyles({
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        flexDirection: "row",
        fontSize: 16,
        width: "auto",
        userSelect: "none",
      }),
      childWrapper: prefixStyles({
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        flexDirection: "row",
        fontSize: 35,
        width: "auto",
        userSelect: "none",
        color: colorTheme,
        ...childWrapperStyle,
      }),
    };

    return (
      <div style={styles.container}>
        <Tappable onTap={onUp}>
          {({ active, tapTargetRefHandler }) => (
            <NoStyleButton
              disabled={upDisabled}
              innerRef={tapTargetRefHandler}
              aria-label="up"
              aria-controls={ariaControls}
              style={{
                ...styles.button,
                backgroundColor: simpleActiveBackgroundColor(active),
              }}
            >
              <IconCircledArrowUp style={styles.upButton} />
            </NoStyleButton>
          )}
        </Tappable>
        {label ? <span style={styles.labelWrapper}>{label}</span> : null}
        {children ? <span style={styles.childWrapper}>{children}</span> : null}
        <Tappable onTap={onDown}>
          {({ active, tapTargetRefHandler }) => (
            <NoStyleButton
              disabled={downDisabled}
              innerRef={tapTargetRefHandler}
              aria-label="down"
              aria-controls={ariaControls}
              style={{
                ...styles.button,
                backgroundColor: simpleActiveBackgroundColor(active),
              }}
            >
              <IconCircledArrowDown style={styles.downButton} />
            </NoStyleButton>
          )}
        </Tappable>
      </div>
    );
  }
}

export default withColorsProvider(NumericUpDownPicker);



// WEBPACK FOOTER //
// ../nx-components/src/PivotNumericUpDownPicker/NumericUpDownPicker.jsx